import React from 'react'
import { Container } from 'react-bootstrap-five'
import Tab from 'react-bootstrap-five/Tab'

type Props = {
  state: string
  children: React.ReactNode
  className?: string
  tabClassName?: string
  // 'xl' (default) matches every existing TabPane consumer — unchanged,
  // back-compat. 'none' drops the 48px Bootstrap `.py-xl` top/bottom padding
  // for a pane whose content brings its own complete vertical-spacing system
  // (e.g. the Unified Feedback Inbox's `INBOX_PAGE_PADDING_PX`,
  // InboxLayout.tsx) — stacking both produced ~72px above the inbox's filter
  // bar card instead of the inbox's own ~24px gutter, read live as "too much
  // space between the tab bar and the filter bar".
  paddingY?: 'xl' | 'none'
  // Defer mounting until the tab is first selected. Tab.Container is used
  // with `transition={false}`, which resolves to NoopTransition — that
  // renders inactive panes unless this is set, so by default every pane's
  // children mount on page load. For a pane holding a Looker embed that
  // means an embed_url fetch and an iframe for a report nobody has opened.
  //
  // Left undefined by default so existing callers are untouched. Panes are
  // NOT unmounted on exit, so switching away and back doesn't refetch.
  mountOnEnter?: boolean
}

const TabPane: React.FC<Props> = props => {
  const {
    state,
    children,
    className = '',
    tabClassName = '',
    paddingY = 'xl',
    mountOnEnter,
  } = props
  const paddingClass = paddingY === 'xl' ? 'py-xl' : ''

  return (
    <Tab.Pane
      className={`${paddingClass} grey-05-bkg ${className}`}
      eventKey={state}
      mountOnEnter={mountOnEnter}
    >
      <Container className={`px-0 ${tabClassName}`}>{children}</Container>
    </Tab.Pane>
  )
}

export default TabPane
